<template lang="pug">
  v-overlay.previewer(
    :value="value",
    z-index="100",
  )
    v-container.pa-0.fill-height(fluid)
      v-row.pa-3.black.previewer_container.fill-height.fill-width(
        no-gutters,
      )
        v-icon.previewer_close.p-absolute(
          @click.native="close",
        ) fas fa-times
        v-col(
          :cols="columnSize",
          v-for="(item, key) in selections",
          :key="'previewer'+key",
        )
          v-card.pa-2.previewer_item.black(tile, outline)
            Projector.fill-height.full-width.d-flex(
              :media="item",
              :ratio="'0'",
              show-control,
            )
        v-col(
          v-if="selections.length === 3",
          cols="6",
        )
          v-card.pa-2.previewer_item.black(tile, outline)
</template>

<script>
import Projector from '@/components/Media/Projector.vue';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },

    selections: {
      type: Array,
      required: true,
    },
  },

  components: {
    Projector,
  },

  mounted() {
    window.addEventListener('keyup', this.closeViaEsc);
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.closeViaEsc);
  },

  computed: {
    columnSize() {
      return this.selections.length === 1 ? '12' : '6';
    },
  },

  methods: {
    closeViaEsc(event) {
      if (event.keyCode === 27) {
        this.close();
      }
    },

    close() {
      this.$emit('update:value', false);
    },
  },
};
</script>

<style lang="scss">
.previewer {
  .v-overlay__content {
    height: 100%;
    width: 100%;
  }

  &_close {
    position: fixed;
    right: 1em;
    top: 1em;
    z-index: 100;
  }

  &_item {
    height: 100%;
    width: 100%;
  }

  &_container {
    overflow: scroll;
  }
}

// .previewer_container {
//   .previewer_item {
//     border: 1px solid white !important;
//   }

//   .col-6:nth-of-type(1) .previewer_item {
//     border-right: 1px solid !important;
//     border-bottom: none !important;
//   }

//   .col-6:nth-of-type(2) .previewer_item {
//     border-left: none !important;
//     border-bottom: none !important;
//   }

//   .col-6:nth-of-type(4) .previewer_item {
//     border-left: none !important;
//   }
// }
</style>
